import { render } from "./setup-my-fatoorah.vue?vue&type=template&id=1de8c0b4"
import script from "./setup-my-fatoorah.vue?vue&type=script&setup=true&lang=js"
export * from "./setup-my-fatoorah.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/whatsapp/setup-my-fatoorah.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1de8c0b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1de8c0b4', __exports__)) {
    console.log('reload')
    api.reload('1de8c0b4', __exports__)
  }
  
  module.hot.accept("./setup-my-fatoorah.vue?vue&type=template&id=1de8c0b4", () => {
    console.log('re-render')
    api.rerender('1de8c0b4', render)
  })

}


export default __exports__